import React from 'react';
import { Box, Typography } from '@mui/material';

interface PageTitleBarProps {
  title: string;
  subtitle?: string;
}

/**
 * Shared page title bar used across all pages.
 * Matches the Dashboard title style: h4 bold title + body1 subtitle.
 */
const PageTitleBar: React.FC<PageTitleBarProps> = ({ title, subtitle }) => {
  return (
    <Box>
      <Typography variant="h4" fontWeight={600} gutterBottom>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default PageTitleBar;
